module.exports = __webpack_public_path__ + "img/modules.ec4ec3ff.png";